import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { FaCheck } from "react-icons/fa";
import { approvePurchaseRequest, getPurchaseRequest } from "redux/erp/purchaseRequestSlice";
import { Modal, Button, FormInput } from 'components/common';

const ApproveForm = ({ show, onHide, purchaseRequest }) => {
  const dispatch = useDispatch();
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async () => {
    setBusy(true);
    try {
      await dispatch(approvePurchaseRequest({ id: purchaseRequest.id, comment })).unwrap();
      await dispatch(getPurchaseRequest(purchaseRequest.id));
      toast.success("Purchase request approved.");
      onHide();
    } catch (e) { toast.error(e?.error || e?.message || "Approval failed."); }
    finally { setBusy(false); }
  };

  return (
    <Modal show={show} onHide={onHide} title={`Approve ${purchaseRequest?.code}`} size="md"
      footer={<>
        <Button variant="secondary" size="sm" disabled={busy} onClick={onHide}>Cancel</Button>
        <Button variant="success" size="sm" leftIcon={FaCheck} disabled={busy} onClick={onSubmit}>Approve</Button>
      </>}>
      <div className="geist-scope">
        <p className="tw-text-sm tw-text-geist-fg-2 tw-mb-3">
          Confirm approval of this purchase requisition? Your signature (from HR Hub) will be attached to the form.
          The next approver will also receive an email to sign instantly if they already have a signature on file.
        </p>
        <FormInput label="Comment (optional)" type="textarea" rows={3} value={comment} onChange={(e) => setComment(e.target.value)} />
      </div>
    </Modal>
  );
};

ApproveForm.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  purchaseRequest: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    code: PropTypes.string,
  }),
};

export default ApproveForm;
